'use client';

import { isValidElement } from 'react';
import { Alert } from '@/app/components/icons/Alert';
import { ErrorIcon } from '@/app/components/icons/ErrorIcon';
import { SITE } from '@/app/constants';
import { cn } from '@/app/utils';
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './toast';
import { STANDARD_TOAST_POSITION_CLASS } from './toast-styles';
import { ToastSuccessIcon } from './toast-success-icon';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection="up">
      {toasts.map(
        ({
          id,
          title,
          message,
          action,
          variant,
          icon,
          containerClassName = STANDARD_TOAST_POSITION_CLASS,
          contentClassName,
          titleClassName,
          closeClassName,
          closable = false,
          ...props
        }) => {
          return (
            <Toast
              key={id}
              {...props}
              className={cn(SITE === 'china' ? "font-['PingFang_SC']" : 'font-Poppins', containerClassName)}
            >
              <div className="grid gap-1">
                {title && <ToastTitle className={titleClassName}>{title}</ToastTitle>}
                {message &&
                  (variant === 'custom' && isValidElement(message) ? (
                    <ToastDescription asChild className={cn('flex items-center gap-2', contentClassName)}>
                      <div>
                        {icon}
                        {message}
                      </div>
                    </ToastDescription>
                  ) : (
                    <ToastDescription className={cn('flex items-center gap-2', contentClassName)}>
                      {variant === 'warning' && <Alert className="size-[18px] shrink-0 text-system-warning" />}
                      {variant === 'error' && <ErrorIcon className="size-[18px] shrink-0 text-system-error1" />}
                      {variant === 'success' && <ToastSuccessIcon />}
                      {variant === 'custom' && icon}
                      {typeof message === 'string' ? <span className="min-w-0">{message}</span> : message}
                    </ToastDescription>
                  ))}
              </div>
              {action}
              {closable && <ToastClose className={closeClassName} />}
            </Toast>
          );
        },
      )}
      <ToastViewport />
    </ToastProvider>
  );
}
